var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 9,
    viewBox: "0 0 232 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333333 4.63672C0.333333 6.10948 1.52724 7.30339 3 7.30339C4.47276 7.30339 5.66667 6.10948 5.66667 4.63672C5.66667 3.16396 4.47276 1.97005 3 1.97005C1.52724 1.97005 0.333333 3.16396 0.333333 4.63672ZM231.354 4.99027C231.549 4.79501 231.549 4.47843 231.354 4.28317L228.172 1.10118C227.976 0.905923 227.66 0.905923 227.464 1.10118C227.269 1.29645 227.269 1.61303 227.464 1.80829L230.293 4.63672L227.464 7.46515C227.269 7.66041 227.269 7.97699 227.464 8.17225C227.66 8.36751 227.976 8.36751 228.172 8.17225L231.354 4.99027ZM3 4.63672V5.13672H231V4.63672V4.13672H3V4.63672Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.956c3e201cd26389e34e34ca3c4dfc43.svg";
export { ForwardRef as ReactComponent };